<template>
  <el-dropdown
    trigger="click"
    class="international"
    @command="handleSetLanguage"
  >
    <div class="international-text" v-if="state == '1'">
      {{ languages }}
      <i class="el-icon-arrow-down"></i>
    </div>
    <div v-else>
      {{ languages }}
      <i class="el-icon-arrow-down"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language === 'zh'" command="zh"
      >中文</el-dropdown-item
      >
      <el-dropdown-item :disabled="language === 'en'" command="en"
      >English</el-dropdown-item
      >
      <el-dropdown-item :disabled="language === 'es'" command="es"
      >ພາສາລາວ</el-dropdown-item>

    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import { mapActions } from "vuex";
export default {
  name: "language",
  props:{
    state:{
      type:String,
      default:'0'
    }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
  },
  data() {
    return {
      languages: "中文",
    };
  },
  mounted() {
    const language = localStorage.getItem('lang') || "zh";
    const showLanguageChangeMessage = !localStorage.getItem('languageChangeMessageShown');

    if (showLanguageChangeMessage) {
      this.handleSetLanguage(language);
    } else {
      this.setLanguage(language);
    }
  },

  methods: {
    ...mapActions("d2admin/account", ["login"]),
    handleSetLanguage(lang) {
      this.setLanguage(lang);
      let changeLangData =JSON.parse(window.sessionStorage.getItem("changeLangData")) 
      // console.log(changeLangData)
      if(changeLangData){
      changeLangData.language = lang
      changeLangData.vm=this
 this.login(changeLangData)
      }
      localStorage.setItem('languageChangeMessageShown', true);
    },

    setLanguage(lang) {
      const languageMapping = {
        zh: { text: "中文", message: "语言切换成功", locale: 'zh_CN' },
        en: { text: "English", message: "Switch Language Success", locale: 'en_US' },
        es: { text: "ພາສາລາວ", message: "ການປ່ຽນແປງພາສາດຜ່ອນເຫດ", locale: 'lo_LA' },
        ja: { text: "日本語", message: "言語切り替えに成功" }
      };

      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang)
      const showLanguageChangeMessage = !localStorage.getItem('languageChangeMessageShown');
      const languageInfo = languageMapping[lang];
      if (languageInfo) {
        this.languages = languageInfo.text;
        if (showLanguageChangeMessage) {
          this.$message({
            message: languageInfo.message,
            type: "success",
          });
        }
        if (languageInfo.locale) {
          window.sessionStorage.setItem('lang', languageInfo.locale);
          this.$eventBus.$emit('langChanged', sessionStorage.getItem('lang'));
        }
      }

      this.$store.dispatch("app/setLanguage", lang);
    }

  }
};
</script>
<style lang="scss">
.international{
  font-size: 18px;
  color: #999999;
  font-weight: 400;
  cursor: pointer;
  .international-text{
    color: #02C362;
    .el-icon-arrow-down{
      color: #02C362;
    }
  }
}
</style>
